export default __webpack_public_path__ + "static/media/golf-pud.36013985.jpg";